export default {
  FETCH_TERMS_OF_USE_REQUEST: 'FETCH_TERMS_OF_USE_REQUEST',
  FETCH_TERMS_OF_USE_SUCCESS: 'FETCH_TERMS_OF_USE_SUCCESS',
  FETCH_TERMS_OF_USE_FAILURE: 'FETCH_TERMS_OF_USE_FAILURE',

  DOWNLOAD_TERMS_OF_USE_REQUEST: 'DOWNLOAD_TERMS_OF_USE_REQUEST',
  DOWNLOAD_TERMS_OF_USE_SUCCESS: 'DOWNLOAD_TERMS_OF_USE_SUCCESS',
  DOWNLOAD_TERMS_OF_USE_FAILURE: 'DOWNLOAD_TERMS_OF_USE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/actions/terms-of-use.action-types.js